import { http, httpRequest, request } from '@/utils/request';
import { CommonResponse, TableReponseType, TableRequestType } from '@/types';

export interface DevicesType {
  image_url: string | undefined;
  property_set_count: string;
  event_report_count: string;
  property_report_count: string;
  id: string;
  name: string;
  product_id: string;
  status: string;
  platform: string;
  cloud_instance_id: string;
  cloud_product_id: string;
  driver_service_name: string;
  product_name: string;
  last_sync_time: number;
  last_online_time: number;
  drive_instance_id: string;
  created: number;
  node_type: string;
  child_device_count: number;
  daily_device_msg_count: { date: string; count: number }[];
  is_alert: boolean;
  // 激活相关
  device_sn?: string;           // 设备唯一编码（用于二维码）
  is_activated?: boolean;       // 是否已激活
  valve_locked?: boolean;       // 电磁阀是否锁止
}

export function getDevice(
  params: TableRequestType & {
    product_id?: string;
    name?: string;
    device_group_id?: string;
  },
) {
  return httpRequest<any, CommonResponse<TableReponseType<DevicesType>>>({
    url: '/api/v1/devices',
    params,
  });
}

export function addDevices(
  data: FormData,
  options: {
    product_id: string;
    driver_instance_id?: string;
  },
) {
  const { product_id, driver_instance_id } = options;
  const querys = [];
  product_id && querys.push(`product_id=${product_id}`);
  driver_instance_id && querys.push(`driver_instance_id=${driver_instance_id}`);
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/devices/import?${querys.join('&')}`,
    method: 'post',
    data,
  });
}

export function deleteDevices(data: { device_ids: string[] }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices',
    method: 'delete',
    data,
  });
}

export function bindDriver(data: { device_ids: string[]; driver_instance_id: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices/bind-driver',
    method: 'put',
    data,
  });
}
export function addSubDevice(data: { device_id: string; child_device_id: string }) {
  return request('/api/v1/device/sub-device', {
    method: 'post',
    data,
  });
}

export function deleteSubDevice(data: { device_id: string; child_device_id: string[] }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device/sub-device',
    method: 'delete',
    data,
  });
}

export function unBindDriver(data: { device_ids: string[] }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/devices/unbind-driver',
    method: 'put',
    data,
  });
}

export function downloadTemplate() {
  return http({
    url: '/api/v1/devices/import-template',
    responseType: 'blob',
  });
}

// 发布产品
export function productRelease<T>(productId: string) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/product-release/${productId}`,
    method: 'post',
  });
}

// 取消产品发布
export function productUnrelease<T>(productId: string) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/product-unrelease/${productId}`,
    method: 'post',
  });
}

export function getGbsip(productId: string) {
  return httpRequest<
    any,
    CommonResponse<{
      id: string;
      product_id: string;
      addr: string; // 服务器地址
      port: number; // 服务器端口
      server_id: string; // 服务器id
      server_region: string; // 服务器域
      password: string; // 服务器密码
    }>
  >({
    url: `/api/v1/gbsip/${productId}`,
  });
}

export function postGbsip(data: { id: string; addr: string; port: number; server_id: string; server_region: string; password: string }) {
  return httpRequest<
    any,
    CommonResponse<{
      id: string;
      product_id: string;
      addr: string; // 服务器地址
      port: number; // 服务器端口
      server_id: string; // 服务器id
      server_region: string; // 服务器域
      password: string; // 服务器密码
    }>
  >({
    url: `/api/v1/gbsip/${data.id}`,
    method: 'put',
    data,
  });
}
